import EventRegisterList from "./EventRegisterList";

export default EventRegisterList;
